import { StepProps } from "../../create-rule/step-props";

export const arrayFilterMap = {
	[StepProps.DefineDuty_InspectionTypes]: e => e.selected,
	[StepProps.DefineDuty_WorkPeriods]: workPeriod => {
		return (
			Object.keys(workPeriod.days).some(day => workPeriod.days[day]) ||
			workPeriod.start !== "00:00 AM" ||
			workPeriod.end !== "00:00 AM"
		);
	},
};
